import { get, post } from './API';

/**
 * Service for visitor tracking admin functionality
 */
const VisitorTrackingService = {
  /**
   * List visitor tracking records with optional filtering
   * @param {object} filters - Optional filters { startDate, endDate, limit, lastKey }
   * @returns {Promise<{ items: Array, lastKey?: string, totalScanned: number }>}
   */
  list: async (filters = {}) => {
    const response = await get('/tracking/admin', filters);
    return response.data;
  },

  /**
   * Get all bookings associated with a tracking record
   * @param {string} token - The tracking token
   * @returns {Promise<{ tracking: object|null, bookings: Array }>}
   */
  getBookings: async (token) => {
    const response = await get(`/tracking/admin/${encodeURIComponent(token)}/bookings`);
    return response.data;
  },

  /**
   * Export confirmed bookings with tracking data as CSV
   * @param {object} filters - Optional filters { startDate, endDate }
   * @returns {Promise<void>} - Triggers download
   */
  exportCSV: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.startDate) params.append('startDate', filters.startDate);
    if (filters.endDate) params.append('endDate', filters.endDate);

    const queryString = params.toString();
    const url = `/tracking/admin/export${queryString ? `?${queryString}` : ''}`;

    // Use fetch with blob response for file download
    const response = await get(url);
    return response;
  },

  /**
   * Manually associate booking IDs with a tracking record
   * @param {string} token - The tracking token
   * @param {string[]} bookingIds - Array of booking IDs to associate
   * @returns {Promise<{ updated: number, errors: string[] }>}
   */
  associateBookings: async (token, bookingIds) => {
    const response = await post(`/tracking/admin/${encodeURIComponent(token)}/associate`, { bookingIds });
    return response.data;
  },
};

export default VisitorTrackingService;
